/**
 * 不检查登录的页面和接口
 */
/**
 * 这个存的是route的name
 */
export const pageRouteName = [
  'login',
  'register',
  'forgetpwd',
];
export const requestUrl = [
  '/regajax/addInsCompany',
  '/appapi/commonajax/getAllInsCompanyList',
  '/appapi/commonajax/getAllProvinceList',
  '/appapi/commonajax/getcitylistbypvid',
  '/appapi/commonajax/getcountylistbyctid',
  '/appapi/commonajax/getinsprovincelistbyinsid',
  '/appapi/websitestyle/basecss',
  '/appapi/jnnotice/getNoticeList',
  '/appapi/auth/getUserNoticeId',
];